import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';

type Props = {
  label: string;
  checked?: boolean;
};

/**
 * ガイド画面で表示用のモックチェックボックス（操作不能）
 */
const GuideMockCheckbox: React.FC<Props> = ({ label, checked = false }) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} size="small" />}
      label={<Typography variant="body2">{label}</Typography>}
      sx={{ pointerEvents: 'none' }}
    />
  );
};

export default GuideMockCheckbox;
